import classNames from "classnames";

import {
  TENANT_ICON_HEIGHT_CLASS,
  TENANT_ICON_WIDTH_CLASS,
} from "features/layout/TenantIcon/constants";

interface Props {
  name?: string;
}

const TenantIconPlaceholder = ({ name }: Props) => {
  const initial = name?.trim().charAt(0).toUpperCase();
  if (!initial) return null;

  return (
    <div
      className={classNames(
        "flex items-center justify-center rounded-sm border border-slate-300 bg-slate-400",
        TENANT_ICON_HEIGHT_CLASS,
        TENANT_ICON_WIDTH_CLASS
      )}
    >
      <span className="text-base font-semibold text-white">{initial}</span>
    </div>
  );
};

export default TenantIconPlaceholder;
